import React, { useContext, useState } from 'react'
import { Icon } from './icon';
import './menu.css'


/**
 * Page Context
 */
export const MenuContext = React.createContext({})

/** 
 * Menu 
 **/
export const Menu = (props) => {
    const { children } = props
    return (
        <ul>
            {children}
        </ul>
    )
}

/**
 * Menu Icon
 */
export const MenuIcon = (props) => {

    const { icon = "more_vert", children, align, size="normal" } = props
    const [open, setOpen] = useState(false)

    function toggle() {
        setOpen(!open)
    }

    return (
        <MenuContext.Provider value={[open, setOpen]}>
            <div className="menu-icon">
                <Icon icon={icon} size={size} clickable action={toggle} />
                {open ? (
                    <menu className={`${align}`}>
                        {children}
                    </menu>
                ) : null}
                {open ? <div className="overlay" onClick={toggle}/> : null}
            </div>
        </MenuContext.Provider>
    )
}

/**
 * Menu Item
 */
export const MenuItem = (props) => {

    const { id, icon, label, meta, disabled=false, onSelect } = props
    const [open, setOpen] = useContext(MenuContext)

    function select() {
        if (!disabled) {
            if (onSelect) onSelect()
            setOpen(false)
        }
    }

    const style = disabled ? "disabled" : ""
    return (
        <li className={`menu-item ${style}`} onClick={select}>
            {icon ? <Icon icon={icon} /> : null}
            <label>{label}</label>
            {meta ? <div className="meta">{meta}</div> : null}
        </li>
    )
}

/**
 * Menu Separator
 */
export const MenuSeparator = (props) => {
    return (
        <li className="menu-separator">
        </li>
    )
}